import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';
import SEO from './components/SEO';
import HeroCrowd from './components/HeroCrowd';

function HomePage() {
  // 企業ロゴのリストをメモ化
  const companyLogos = useMemo(() => [
    'cyberaganet.png',
    'excite.png',
    'omnibus.png',
    'sbibs.png',
    'sourcenext.png',
    'speee.png',
    'Sumareji.png',
    'syumatuworker.png',
    'TBM.png',
    'timers.png',
    'torihada.png',
    'uniforce.png',
    'Zials.png'
  ], []);

  // ニュースデータ（linkがない場合はクリック不可）
  const newsItems = useMemo(() => [
    {
      date: '2026.10.9',
      category: 'プレスリリース',
      title: '九州最大級のスタートアップイベント「StartupGo!Go! 2026」のピッチコンテスト「The Pitch」セミファイナルに登壇しました',
      link: 'https://startup-gogo.com/event/',
    },
    {
      date: '2026.3.14',
      category: 'お知らせ',
      title: 'クロスワーク・マガジンで当社が紹介されました。',
      link: 'https://x-work.jp/journal/article/46526',
    },
    {
      date: '2025.9.1',
      category: 'お知らせ',
      title: 'OSUMITSUKI「スキルの通知表/スキルの拡張パック」をリリースしました',
      link: null,
    },
    {
      date: '2024.5.24',
      category: 'プレスリリース',
      title: 'B Dash Camp2024 Sapporo　ファイナリストとなりました',
      link: null,
    },
    {
      date: '2022.11.4',
      category: 'プレスリリース',
      title: 'きらぼし銀行アクセラレーターに採択',
      link: null,
    },
  ], []);

  return (
    <div>
      <SEO page="home" />
      
      {/* 1. ファーストビュー（TOP） */}
      <HeroCrowd />

      {/* 2. サービス一覧（全体像） */}
      <section className="ds-section ds-section--alt home-services">
        <div className="container">
          <div className="ds-section-head">
            <p className="ds-eyebrow">Service</p>
            <h2 className="ds-h2">
              共通評価データを基盤にしたサービス「OSUMITSUKI」
            </h2>
          </div>

          <div className="home-services-grid">
            <Link to="/service" className="ds-card home-service-card home-service-card--recruit">
              <div className="home-service-logo">
                <img
                  src="/images/rogo_recruit.png"
                  alt="転職のセンター試験ロゴ"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <h3 className="home-service-name">センター試験型転職サービス</h3>
            </Link>

            <a href="https://pack.p-osumitsuki.com/" target="_blank" rel="noopener noreferrer" className="ds-card home-service-card home-service-card--expansion">
              <div className="home-service-logo">
                <img
                  src="/images/rogo_expansion.png"
                  alt="拡張パックロゴ"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <h3 className="home-service-name">フルオーダーメイド教育サービス</h3>
            </a>
          </div>

          {/* 受賞・採択歴 */}
          <div className="home-awards">
            <div>
              <p className="ds-eyebrow">Awards</p>
              <h3 className="ds-h3">受賞・採択歴</h3>
            </div>
            <ul className="home-award-list">
              <li className="home-award-item">きらぼし銀行アクセラレーター採択</li>
              <li className="home-award-item">BDASH CAMP 2024ファイナリスト</li>
            </ul>
          </div>
        </div>
      </section>

      {/* 4. 導入事例・お客様の声 */}
      <section className="ds-section home-cases">
        <div className="container">
          <div className="ds-section-head ds-section-head--row">
            <div>
              <p className="ds-eyebrow">Case Study</p>
              <h2 className="ds-h2">導入事例・お客様の声</h2>
            </div>
            <Link to="/case-studies" className="ds-link">導入企業の声はこちら</Link>
          </div>
        </div>

        {/* 企業ロゴ流し（2周分を並べて -50% 動かすと継ぎ目なく回る） */}
        <div className="home-logos" aria-label="導入企業">
          <div className="home-logos-track">
            {[...Array(2)].map((_, loopIndex) =>
              companyLogos.map((logo, index) => (
                <div
                  key={`${loopIndex}-${index}`}
                  className="home-logo-item"
                  aria-hidden={loopIndex > 0 ? 'true' : undefined}
                >
                  <img
                    src={`/images/logoall/${logo}`}
                    alt={loopIndex > 0 ? '' : logo.replace('.png', '')}
                    decoding="async"
                  />
                </div>
              ))
            )}
          </div>
        </div>

        <div className="container">
          {/* 実績数値 */}
          <dl className="home-kpis">
            <div className="home-kpi">
              <dt className="home-kpi-label">累計導入企業数</dt>
              <dd className="home-kpi-value">
                <span className="ds-num">200</span><small>社+</small>
              </dd>
            </div>
            <div className="home-kpi">
              <dt className="home-kpi-label">月間評価件数（直近実績）</dt>
              <dd className="home-kpi-value">
                <span className="ds-num">30</span><small>万件規模</small>
              </dd>
            </div>
            <div className="home-kpi">
              <dt className="home-kpi-label">採用リードタイム</dt>
              <dd className="home-kpi-value">
                <small>最短</small><span className="ds-num">1</span><small>週間</small>
              </dd>
            </div>
          </dl>

          <p className="home-kpi-note">注）数値は直近実績に基づきます。詳細はお問い合わせください。</p>

          <div className="home-case-grid">
            <Link to="/case-study/1" className="ds-card home-case-card">
              <h3 className="home-case-company">株式会社ペッツオーライ様</h3>
              <p className="home-case-result">
                <span className="home-case-before">採用率1〜2％</span>
                <span className="home-case-arrow" aria-hidden="true">→</span>
                <span>66％に改善</span>
              </p>
              <p className="home-case-text">
                OSUMITSUKI導入により、採用効率が大幅に向上し、質の高い人材の獲得に成功。
              </p>
            </Link>

            <Link to="/case-study/2" className="ds-card home-case-card">
              <h3 className="home-case-company">株式会社スマレジ様</h3>
              <p className="home-case-result">面接効率化と内定率向上</p>
              <p className="home-case-text">
                面接時間の削減と内定率の向上を同時に実現。
              </p>
            </Link>

            <Link to="/case-study/3" className="ds-card home-case-card">
              <h3 className="home-case-company">HRテクノロジーズ株式会社様</h3>
              <p className="home-case-result">中立的な評価が役立った</p>
              <p className="home-case-text">
                懸念点まで含めた中立的な評価により、より適切な採用判断が可能に。
              </p>
            </Link>
          </div>
        </div>
      </section>

      {/* 5. ニュース・お知らせ */}
      <section className="ds-section ds-section--alt home-news">
        <div className="container">
          <div className="ds-section-head">
            <p className="ds-eyebrow">News</p>
            <h2 className="ds-h2">ニュース・お知らせ</h2>
          </div>

          <ul className="home-news-list">
            {newsItems.map((item, index) => (
              <li key={index} className="home-news-item">
                <time className="home-news-date ds-num">{item.date}</time>
                <span className="home-news-category">
                  <span className="ds-tag">{item.category}</span>
                </span>
                <p className="home-news-title">
                  {item.link && /^https?:\/\//.test(item.link) ? (
                    <a href={item.link} target="_blank" rel="noopener noreferrer">{item.title}</a>
                  ) : item.link ? (
                    <Link to={item.link}>{item.title}</Link>
                  ) : (
                    <span>{item.title}</span>
                  )}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* 6. 採用情報・お問い合わせ */}
      <section className="ds-section home-join">
        <div className="container">
          <div className="home-join-grid">
            <div className="home-join-block">
              <p className="ds-eyebrow">Recruit</p>
              <h2 className="ds-h2">採用情報</h2>
              <p className="ds-lead">
                一緒に"社会的な評価基準"をつくる仲間を募集しています。
              </p>
              <Link to="/recruit" className="ds-btn ds-btn--line ds-btn--arrow">
                現在募集中の職種一覧
              </Link>
            </div>

            <div id="contact" className="home-join-block">
              <p className="ds-eyebrow">Contact</p>
              <h2 className="ds-h2">お問い合わせ</h2>
              <p className="ds-lead">
                サービスの詳細を知りたい、デモを依頼したい方はお気軽にお問い合わせください。
              </p>
              <Link to="/contact" className="ds-btn ds-btn--primary ds-btn--arrow">
                お問い合わせフォーム
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;